import "./ContactPage.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ServiceAreaStatement from "./sections/ServiceAreaStatement";
import ContactSection from "./sections/ContactSection";
import Footer from "@/reusable_sections/Footer";
export default function ContactPagePage() {
  return <div>
      <Header />
      <Hero />
      <ServiceAreaStatement />
      <ContactSection />
      <Footer />
    </div>;
}